'use client';

import type { JSX } from 'react';
import { useVisualViewport } from '@/hooks/ui/use-visual-viewport';

/**
 * Mounts the visual-viewport sync hook at the app root.
 * Sets `--keyboard-offset` on `<html>` so that bottom sheets and dialogs
 * shift up when the mobile keyboard opens.
 *
 * Renders no DOM — purely a side-effect provider.
 */
export function ViewportProvider() {
  useVisualViewport();
  return null;
}